// extracted by mini-css-extract-plugin
module.exports = {"singleTrainer":"SingleTrainer_singleTrainer__auCrr","trainerName":"SingleTrainer_trainerName__FEAar","gymAccess":"SingleTrainer_gymAccess__3UDgw"};